import { render, staticRenderFns } from "./RedeemCouponThroughLink.vue?vue&type=template&id=b285defe&scoped=true"
import script from "./RedeemCouponThroughLink.vue?vue&type=script&lang=js"
export * from "./RedeemCouponThroughLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b285defe",
  null
  
)

export default component.exports